// import components and utils
import { alpha, Switch } from '@mui/material';

// import constants
import { BLUE, DARK, PRIMARY, YELLOW } from 'constants/colors';

// import types
import { ColoredSwitchProps } from './Switch.types';

export const createColoredSwitch = (defaultColor: string) => {
  return ({ groupBy, ...props }: ColoredSwitchProps) => (
    <Switch
      {...props}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: !groupBy ? defaultColor : 'default',
          '&:hover': {
            backgroundColor: !groupBy ? alpha(defaultColor, 0.2) : 'transparent'
          }
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: !groupBy ? defaultColor : 'default',
          border: `2px solid ${defaultColor}`
        }
      }}
    />
  );
};

// create and export the switches
export const DarkSwitch = createColoredSwitch(DARK);
export const YellowSwitch = createColoredSwitch(YELLOW);
export const BlueSwitch = createColoredSwitch(BLUE);
export const PrimarySwitch = createColoredSwitch(PRIMARY);
